<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_users"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Audience <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-text label="Name" v-model="resource.name"></form-text>

                                <form-textarea label="Description" v-model="resource.description"></form-textarea>

                                <div v-if="audience" class="audience-contacts-info" v-bind:class="{'updated':audienceUpdated}">
                                    <span>Audience touchée</span>
                                    <strong>{{ audience.count }} personne(s)</strong>
                                </div>

                                <component-conditions v-model="resource.filters" :options="options"></component-conditions>

                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import AudienceService from './AudienceService.js';
    import Edit from '../../../layouts/Edit.vue';

    import ComponentConditions from "../../../components/Conditions.vue";

    export default {
        extends: Edit,
        components: {
            'component-conditions': ComponentConditions
        },
        data () {
            return {
                debounce: null,
                audienceUpdated: false,
                audience: null,
                options: [],
                options_default: [
                    {
                        id:"person.locale",
                        name: "Locale",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'},
                            {id:'is_null', name:'is empty'},
                            {id:'is_not_null', name:'is not empty'}
                        ]
                    },
                    {
                        id:"person.firstname",
                        name: "Firstname",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'},
                            {id:'is_null', name:'is empty'},
                            {id:'is_not_null', name:'is not empty'}
                        ]
                    },
                    {
                        id:"person.lastname",
                        name: "Lastname",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'},
                            {id:'is_null', name:'is empty'},
                            {id:'is_not_null', name:'is not empty'}
                        ]
                    },
                    {
                        id:"person.email",
                        name: "Email",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'},
                            {id:'is_null', name:'is empty'},
                            {id:'is_not_null', name:'is not empty'}
                        ]
                    },
                    {
                        id:"person.phone_mobile",
                        name: "Téléphone Mobile",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'},
                            {id:'is_null', name:'is empty'},
                            {id:'is_not_null', name:'is not empty'}
                        ]
                    },
                    {
                        id:"person.birthdate",
                        name: "Birthdate",
                        operators:[
                            {id:'is_today', name:'is today'},
                            {id:'is_in_days', name:'is in (x) days'}
                        ]
                    }
                ]
            }
        },
        mounted: function(){

            AudienceService.contact().then(response => {
                console.log(response)
                this.audience = response.data
                this.isLoading = false
            })

        },
        methods:{
            resourceLoaded: function(){
                this.resource.filters = this.resource.filters || [];

                this.options = this.options_default
                if( this.resource.attributes ){
                  for(let item of this.resource.attributes){
                    this.options.push({
                      id: 'attributable.' + item.attribute_id,
                      name: item.name
                    })
                  }
                }

                this.initialize()
            },
            beforeUpdate: function(Resource){

                return true;
            },
            getResource: function(){
                return AudienceService
            },
            updateFilter: function(filters){

                let self = this

                clearInterval(self.debounce);
                self.debounce = setTimeout(function(){
                    self.isLoading = false
                    AudienceService.contact(filters).then(response => {
                        console.log(response)
                        self.audience = response.data
                        self.isLoading = false
                        self.audienceUpdated = true;
                    })

                }, 2000)

            }
        },
        watch: {
            'resource.filters': {
                handler: function(newVal, oldVal) {
                    this.audienceUpdated = false;
                    this.updateFilter(newVal)
                },
                deep: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/audience/Edit.vue